import BsjSetTriggerAlarmModal from './bsj-set-trigger-alarm-modal.vue'
export default BsjSetTriggerAlarmModal
